// src/modules/app-views/leads/pages/Init/components/tableColumns/statusColumn.js
import { Tag } from 'antd';
import translateX from 'utils/translateX';

function statusColumn(buildColumnProps, options = {}) {
  const {
    key = 'status',
    title = 'status',
    dataIndex = 'status',
    width = 120,
    align = 'center',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const status = r?.status || 'queue';
      const cfg = {
        queue:       { color: 'orange',     label: 'queue' },
        available:   { color: 'blue',       label: 'available' },
        pending:     { color: 'default',    label: 'pending' },
        processing:  { color: 'processing', label: 'processing' },
        assigned:    { color: 'cyan',       label: 'assigned' },
        delivered:   { color: 'geekblue',   label: 'delivered' },
        purchased:   { color: 'green',      label: 'purchased' },
        in_progress: { color: 'processing', label: 'in_progress' },
        converted:   { color: 'success',    label: 'converted' },
        discarded:   { color: 'error',      label: 'discarded' },
        lost:        { color: 'error',      label: 'lost' },
        no_contact:  { color: 'warning',    label: 'no_contact' },
      };
      const { color, label } = cfg[status] || { color: 'default', label: status };
      return <Tag color={color}>{translateX(label)}</Tag>;
    },
  };
}

export default statusColumn;
